import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getJobsInProgress = createAsyncThunk('jobs/getJobsInProgress',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/jobs/in-progress',
        {
          params
        });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getJobsInProgress;
